/* eslint-disable react/forbid-prop-types */
import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const RolePermissionsPropTypes = PropTypes.shape({
    _id: PropTypes.string,
    roleTitle: PropTypes.string,
    permissions: PropTypes.array,
});

export const RolePermissionsDefaultProps = {
    roleTitle: '',
    permissions: [],
};

export const RolePermissionsYupSchema = Yup.object().shape({
    roleTitle: Yup.string().required('Required'),
    permissions: Yup.array().required('Required').min(1, 'Give at least 1 Permissions'),
});

export default {
    RolePermissionsDefaultProps,
    RolePermissionsPropTypes,
    RolePermissionsYupSchema,
};
